module.exports = __webpack_public_path__ + "static/media/logo_qas.34aee69b.png";